import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review, pulled from Sweet Wink's live Faire brand page
// reviews carousel — verbatim reviewer name/location/text/date. See
// review_sw9.ts for the note on purchased-product thumbnails; this one pairs
// with 2 real, already-imported apparel SKUs.
export const review_sw10: FaireReviewEntity = {
  token: "review_sw10",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  reviewerName: "Cassandra",
  reviewerLocation: "Parker, CO, United States",
  stars: 5,
  reviewText:
    "One of our favorite, best selling brands! They always provide excellent communication and prompt shipping. Item are adorable and high quality. We regularly place orders with this brand.",
  reviewDate: "Jan 16, 2026",
  reviewType: "brand",
  purchasedProductTokens: ["p_a4j6hrv2jp", "p_qdvwsr2pxw"],
  meta: {
    source: "api",
    importedAt: "2026-08-12T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
